<template>
  <div class="content-wrapper">
    <Unsupported
      v-if="currentStep === 'unsupported'"
      :organization-id="organizationId"
      :organization-name="organizationName"
      @show-product-detail-full-screen-dialog="
        showProductDetailFullScreenDialog = true
      "
    />
    <AlreadyExistInCart
      v-else-if="currentStep === 'alreadyExistInCart'"
      :organization-id="organizationId"
      :sales-management-id="salesManagementId"
      @show-product-detail-full-screen-dialog="
        showProductDetailFullScreenDialog = true
      "
    />
    <SelectKid
      v-else-if="currentStep === 'selectKid' && combookBinding"
      :organization-name="combookBinding.organization.name"
      :family-name="combookBinding.family.name"
      :organization-id="organizationId"
      :kids="combookBinding.kids"
      :selected-kid="selectedKid"
      @update:selectedKid="handleSelectedKidUpdate"
      @show-product-detail-full-screen-dialog="
        showProductDetailFullScreenDialog = true
      "
      @next="goToSelectPeriod"
    />
    <SelectPeriod
      v-else-if="currentStep === 'selectPeriod'"
      :price="price"
      :family-name="combookBinding.family.name"
      :organization-name="combookBinding.organization.name"
      :selected-kid="selectedKid"
      :selected-year="selectedYear"
      :selected-period="selectedPeriod"
      @update:selectedYear="selectedYear = $event"
      @update:selectedPeriod="selectedPeriod = $event"
      @show-product-detail-full-screen-dialog="
        showProductDetailFullScreenDialog = true
      "
      @back="goToSelectKid"
      @next="goToSelectDesignType"
    />
    <SelectDesignType
      v-else-if="currentStep === 'selectDesignType'"
      :selected-design-type="selectedDesignType"
      @update:selectedDesignType="selectedDesignType = $event"
      @back="goToSelectPeriod"
      @next="goToEditCoverText"
    />
    <EditCoverText
      v-else-if="currentStep === 'editCoverText'"
      :organization-name="organizationName"
      :kid-name="kidName"
      :selected-period="selectedPeriod"
      :selected-design-type="selectedDesignType"
      @update:organizationName="organizationName = $event"
      @update:kidName="kidName = $event"
      @back="goToSelectDesignType"
      @next="goToEditCoverImage"
    />
    <EditCoverImage
      v-else-if="currentStep === 'editCoverImage'"
      :organization-id="organizationId"
      :organization-name="organizationName"
      :kid-name="kidName"
      :selected-kid="selectedKid"
      :selected-period="selectedPeriod"
      :selected-design-type="selectedDesignType"
      @update:selectedDesignType="selectedDesignType = $event"
      @coverGenerated="handleCoverGenerated"
      @back="goToEditCoverText"
      @next="goToConfirm"
    />
    <Confirm
      v-else-if="currentStep === 'confirm'"
      :price="price"
      :family-name="combookBinding.family.name"
      :organization="combookBinding.organization"
      :organization-name="organizationName"
      :kid-name="kidName"
      :selected-kid="selectedKid"
      :selected-period="selectedPeriod"
      :selected-design-type="selectedDesignType"
      :combook-binding-cover="combookBindingCover"
      @ignore-before-route-leave="ignoreBeforeRouteLeave = true"
      @show-product-detail-full-screen-dialog="
        showProductDetailFullScreenDialog = true
      "
      @back="goToEditCoverImage"
      @already-exist-in-cart="handleAlreadyExistInCartFromConfirm"
    />

    <ConfirmNavigationDialog
      :dialog="showConfirmDialog"
      message="このページから移動すると、作成中の内容は保存されません。移動しますか？"
      @confirm="confirmNavigation"
      @cancel="cancelNavigation"
    />

    <IosSafariTabBarBackgroundBar
      v-show="showProductDetailFullScreenDialog"
    ></IosSafariTabBarBackgroundBar>

    <ProductDetailFullScreenDialog
      :dialog="showProductDetailFullScreenDialog"
      :price-combook-binding="price"
      @close-dialog="showProductDetailFullScreenDialog = false"
    />

    <TermsAndPolicy
      v-if="agreementVersions"
      :agreement-versions="agreementVersions"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";

import ApiErrorHandler from "../../mixins/ApiErrorHandler";
import { API_ERROR_CODE_VALIDATION_COMBOOK_BINDING_PRICE_NOT_SET } from "../../lib/lookmee_photo/ApiErrorCodes";

import IosSafariTabBarBackgroundBar from "packs/site/components/IosSafariTabBarBackgroundBar.vue";

import SelectKid from "./components/pages/SelectKid";
import SelectPeriod from "./components/pages/SelectPeriod";
import SelectDesignType from "./components/pages/SelectDesignType";
import EditCoverText from "./components/pages/EditCoverText";
import EditCoverImage from "./components/pages/EditCoverImage";
import Confirm from "./components/pages/Confirm";
import Unsupported from "./components/pages/Unsupported";
import ConfirmNavigationDialog from "../../components/ConfirmNavigationDialog";
import AlreadyExistInCart from "./components/pages/AlreadyExistInCart";
import ProductDetailFullScreenDialog from "../../components/combook_binding/ProductDetailFullScreenDialog";
import TermsAndPolicy from "../../components/TermsAndPolicy.vue";

export default {
  name: "CombookBindingIndex",
  components: {
    IosSafariTabBarBackgroundBar,
    SelectKid,
    SelectPeriod,
    SelectDesignType,
    EditCoverText,
    EditCoverImage,
    Confirm,
    Unsupported,
    ConfirmNavigationDialog,
    AlreadyExistInCart,
    ProductDetailFullScreenDialog,
    TermsAndPolicy
  },
  mixins: [ApiErrorHandler],
  props: {
    organizationId: {
      type: Number,
      required: true
    }
  },
  // FIXME: CombookBindingCoverをPOSTするためのプロパティはオブジェクトでまとめた方がいいかも
  data() {
    return {
      currentStep: "selectKid",
      price: "",
      selectedKid: null,
      selectedYear: null,
      selectedPeriod: null,
      selectedDesignType: "pastel",
      organizationName: "",
      kidName: "",
      combookBindingCover: null,
      combookBinding: null,
      salesManagementId: null,
      showConfirmDialog: false,
      pendingNavigation: null,
      ignoreBeforeRouteLeave: false,
      showProductDetailFullScreenDialog: false,
      agreementVersions: undefined
    };
  },
  computed: {
    ...mapState({
      apiClient: "apiClient"
    }),
    hasDataChanged() {
      if (["unsupported", "alreadyExistInCart"].includes(this.currentStep)) {
        // 価格未設定画面、すでにカートに入っている画面ではデータ変更できないのでダイアログは出さない
        return false;
      }
      return this.organizationName !== "" || this.kidName !== "";
    }
  },
  watch: {
    selectedKid(newKid, oldKid) {
      const kidIdUnchanged = newKid && oldKid && newKid.id === oldKid.id;
      if (kidIdUnchanged) {
        return;
      }

      this.selectedYear = null;
      this.selectedPeriod = null;
    }
  },
  async created() {
    this.$store.dispatch("startLoading");
    try {
      this.agreementVersions = await this.apiClient.getAgreementVersions();
      const cart = await this.fetchCombookBindingCart();
      await this.fetchCombookBinding();
      this.$store.commit("cart/setCart", cart);

      if (cart) {
        this.handleAlreadyExistInCartFromConfirm(cart.salesManagementId);
        return;
      }
    } finally {
      this.$store.dispatch("endLoading");
    }
  },
  mounted() {
    window.addEventListener("beforeunload", this.handleBeforeUnload);
    // オーバースクロールを防ぐ
    document.documentElement.style.overscrollBehavior = "none";
  },
  beforeDestroy() {
    window.removeEventListener("beforeunload", this.handleBeforeUnload);
    // オーバースクロールの制限を解除
    document.documentElement.style.overscrollBehavior = "";
  },
  // ページ遷移時の確認ダイアログ表示
  beforeRouteLeave(to, from, next) {
    if (this.ignoreBeforeRouteLeave || !this.hasDataChanged) {
      next();
    } else {
      this.showNavigationConfirmDialog(next);
    }
  },
  methods: {
    async fetchCombookBinding() {
      try {
        this.combookBinding = await this.apiClient.fetchCombookBinding(
          this.organizationId
        );
        if (this.combookBinding && this.combookBinding.organization) {
          this.organizationName = this.combookBinding.organization.name;
        }
        if (this.combookBinding && this.combookBinding.price) {
          this.price = this.combookBinding.price;
        }
      } catch (errors) {
        if (
          errors.status === 400 &&
          typeof errors.getErrorCode === "function" &&
          errors.getErrorCode() ===
            API_ERROR_CODE_VALIDATION_COMBOOK_BINDING_PRICE_NOT_SET
        ) {
          const response = errors.response && errors.response.data;
          this.currentStep = "unsupported";
          this.scrollToTop();
        } else {
          this.handleApiErrors(errors, {
            store: this.$store,
            router: this.$router,
            sentry: this.sentry
          });
        }
      }
    },
    async fetchCombookBindingCart() {
      try {
        return await this.apiClient.existsCombookBindingInCart(
          this.organizationId
        );
      } catch (errors) {
        if (errors.status === 404) {
          // 連絡帳製本の価格が未設定の場合、404が返される。何もしないと404エラーページになってしまうが、この場合専用エラーを表示したいのでcatchしてnullを返す。
          return null;
        }

        this.handleApiErrors(errors, {
          store: this.$store,
          router: this.$router,
          sentry: this.sentry
        });
      }
    },
    scrollToTop() {
      this.$nextTick(() => {
        window.scrollTo(0, 0);
      });
    },
    goToSelectPeriod() {
      this.currentStep = "selectPeriod";
      this.scrollToTop();
    },
    goToSelectKid() {
      this.currentStep = "selectKid";
      this.scrollToTop();
    },
    goToSelectDesignType() {
      this.currentStep = "selectDesignType";
      this.scrollToTop();
    },
    goToEditCoverText() {
      this.currentStep = "editCoverText";
      this.scrollToTop();
    },
    goToEditCoverImage() {
      this.currentStep = "editCoverImage";
      this.scrollToTop();
    },
    goToConfirm() {
      this.currentStep = "confirm";
      this.scrollToTop();
    },
    handleAlreadyExistInCartFromConfirm(salesManagementId) {
      this.salesManagementId = salesManagementId;
      this.currentStep = "alreadyExistInCart";
      this.scrollToTop();
    },
    handleCoverGenerated(coverData) {
      this.combookBindingCover = coverData;
    },
    handleSelectedKidUpdate(kid) {
      const familyName = this.combookBinding.family.name;
      const kidFullName = kid ? `${familyName} ${kid.name}` : "";
      this.selectedKid = kid;
      this.kidName = kidFullName;
    },
    // ブラウザのリロードやタブを閉じる操作時の確認ダイアログ表示
    handleBeforeUnload(event) {
      if (this.hasDataChanged) {
        event.preventDefault();
        // ここは任意の文字をセットしても、セキリティの関係で結局デフォルトの文字列が表示されるようです。
        // でも何かをセットしないといけないので、とりあえずこの文字列をセットしています。
        event.returnValue =
          "このページから移動すると、作成中の内容は保存されません。移動しますか？";
        return event.returnValue;
      }
    },
    showNavigationConfirmDialog(next) {
      this.pendingNavigation = next;
      this.showConfirmDialog = true;
    },
    closeNavigationDialog() {
      this.showConfirmDialog = false;
      this.pendingNavigation = null;
    },
    confirmNavigation() {
      if (this.pendingNavigation) {
        this.pendingNavigation();
      }
      this.closeNavigationDialog();
    },
    cancelNavigation() {
      if (this.pendingNavigation) {
        this.pendingNavigation(false);
      }
      this.closeNavigationDialog();
    }
  }
};
</script>

<style scoped>
.content-wrapper {
  max-width: 443px;
  width: 100%;
  margin: 0 auto;
}
</style>
